import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-2">
            <i className="ri-grid-line text-accent-500 text-lg"></i>
            <span className="text-xs font-medium text-accent-600 bg-accent-100 px-2.5 py-1 rounded-full whitespace-nowrap">漫画分类</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            韩漫 · 日漫 · 国漫 全都有
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-xl mx-auto">
            覆盖三大主流漫画类型，每类精选数千部优质作品，满足你的所有阅读口味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-6 md:p-8 hover:bg-background-50 transition-all duration-300 border border-background-200/70 hover:border-primary-200 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300 mb-5">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-xl text-foreground-900 mb-2">{cat.name}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">{cat.description}</p>
              <span className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium group-hover:gap-2 transition-all whitespace-nowrap">
                浏览{cat.name} <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}